import { render, staticRenderFns } from "./PictureUploader.vue?vue&type=template&id=12471082&"
import script from "./PictureUploader.vue?vue&type=script&lang=js&"
export * from "./PictureUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports